import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { modifiers as m } from 'vue-tsx-support';
import { Nothing } from '@codegrade/maybe';
import * as models from '@/models';
import TenantListItem from './TenantListItem';
export default tsx.componentFactoryOf().create({
    name: 'tenant-list',
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            searchTerm: '',
        };
    },
    props: {
        allTenants: p.ofRoArray().required,
        focusInput: p(Boolean).default(false),
        getTenantUrl: p
            .ofFunction()
            .default(() => Nothing),
    },
    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        tenants() {
            return models.Tenant.Searcher.search(this.searchTerm, this.allTenants);
        },
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        renderTenant(tenant) {
            const inner = (<TenantListItem tenant={tenant} scopedSlots={{ extra: this.$scopedSlots.extra }}/>);
            const link = this.getTenantUrl(tenant).caseOf({
                Nothing: () => <div>{inner}</div>,
                Just: url => (<router-link class="d-block text-default" to={url}>
                        {inner}
                    </router-link>),
            });
            return <li class="list-group-item p-0">{link}</li>;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        maybeSelectTenant() {
            if (this.tenants.length > 0) {
                this.getTenantUrl(this.tenants[0]).ifJust(url => this.$router.push(url));
            }
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        return (<div class="tenant-list">
                <input v-model={this.searchTerm} class="form-control my-2" placeholder="Search for your institution" v-focus={this.focusInput} onKeydown={m.enter(this.maybeSelectTenant)}/>

                <ul class="list-group alternating">
                    {this.tenants.map(t => this.renderTenant(t))}
                </ul>
            </div>);
    },
});
